import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';

import Button from '@mui/material/Button';

interface DetailsCellProps {
  value: unknown;
  onClick: (value: unknown) => void;
  disabled?: boolean;
}

const DetailsCell: React.FC<DetailsCellProps> = ({ value, onClick, disabled = false }) => {
  const { formatMessage } = useIntl();

  const handleClick = useCallback(() => onClick(value), [onClick, value]);

  return (
    <Button variant="text" size="small" onClick={handleClick} disabled={disabled}>
      {formatMessage({
        id: 'button.view',
        defaultMessage: 'View',
      })}
    </Button>
  );
};

export default DetailsCell;
